import { render } from "./TicketModal.vue?vue&type=template&id=5ba89a13&scoped=true"
import script from "./TicketModal.vue?vue&type=script&lang=js"
export * from "./TicketModal.vue?vue&type=script&lang=js"

import "./TicketModal.vue?vue&type=style&index=0&id=5ba89a13&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba89a13"]])

export default __exports__